import axios from 'axios';
import EnvironmentService from './environment';
import Authorization from './authorization';

const api = axios.create({
    baseURL: `${EnvironmentService.baseURL()}/api`,
    timeout: 30000,
    responseType: 'json'
});

class SubscriptionService {
    static async create(creatorId, paymentMethodId) {
        const headers = await Authorization.authorizationHeader();
        return api.post('/subscriptions', { creatorId, paymentMethodId }, { headers });
    }

    static async cancel(subscriptionId) {
        const headers = await Authorization.authorizationHeader();
        return api.delete(`/subscriptions/${subscriptionId}`, { headers });
    }

    static async listMine() {
        const headers = await Authorization.authorizationHeader();
        return api.get('/subscriptions', { headers });
    }
}

export default SubscriptionService;
